import React from 'react';
import TyreRepairRequest from './TyreRepairRequest';
import { TyrePageState, TyreProcessStages } from './TyreRepairRequestTypes';
import './TyreRepairRequest.scss';
import TyreRepairRequestProvider from '../../../context/TyreRepairRequestProvider';
import ReloadHandler from '../../common/ReloadHandler';
import { RoutePaths } from '../../../Constants/Common';
import { useSelectedProduct } from '../../hooks/useSelectedProduct';
import { useSelectedVehicle } from '../../hooks/useSelectedVehicle';

const TyreRepairRequestManager = (): JSX.Element => {
    const initialState: TyrePageState = {
        mileage: '',
        tyreRepairRequests: [],
        tyreFormErrors: undefined,
        repairRequestSelectedIndex: -1,
        tyreStage: TyreProcessStages.General,
        repairAddresses: [],
        dealerAddress: undefined,
        selectedRepairAddressId: null,
        hasErrors: false,
        permissionGranted: false,
        currentRepairRequest: undefined,
        showCancelAlert: false,
        updateTyre: '',
        scrollToAddress: false,
        isLoadingOnSubmission: false
    };

    const vehicle = useSelectedVehicle();
    const { product } = useSelectedProduct();

    return (
        <TyreRepairRequestProvider
            initialState={initialState}
            product={product}
            vehicle={vehicle}>
            <TyreRepairRequest />
            <ReloadHandler reloadPath={RoutePaths.LandingPage} />
        </TyreRepairRequestProvider>
    );
};

export default TyreRepairRequestManager;
